<template>
  <div>
    <a-affix :offset-top="top">
      <div>
        <a-menu
          v-model="current"
          mode="horizontal"
          @select="menuSelect"
          @click="menuClick"
        >
          <a-menu-item
            ><router-link to="/index" tag="div"> 首页</router-link></a-menu-item
          >
          <a-sub-menu @titleClick="titleClick">
            <span slot="title" class="submenu-title-wrapper"
              ><router-link
                :to="{ path: '/scAbout', query: { name: '学校简介' } }"
                tag="div"
                >学校概况</router-link
              ></span
            >
            <a-menu-item
              ><router-link
                :to="{ path: '/scAbout', query: { name: '学校简介' } }"
                tag="div"
                >学校简介</router-link
              ></a-menu-item
            >
            <!-- <a-menu-item
              ><router-link
                :to="{ path: '/scAbout', query: { name: '组织结构' } }"
                tag="div"
                >组织结构</router-link
              ></a-menu-item
            > -->
            <a-menu-item
              ><router-link
                :to="{ path: '/scAbout', query: { name: '校园风光' } }"
                tag="div"
                >校园风光</router-link
              ></a-menu-item
            >
            <!-- <a-menu-item
              ><router-link
                :to="{ path: '/special', query: { classId: li_classId, classCName: li_classCName,name: '现任领导' } }"
                tag="div"
                >现任领导</router-link
              ></a-menu-item
            > -->
            <a-menu-item
              ><router-link
                :to="{ path: '/scAbout', query: { name: '领导关怀' } }"
                tag="div"
                >领导关怀</router-link
              ></a-menu-item
            >
          </a-sub-menu>
          <a-sub-menu @titleClick="titleClick">
            <span slot="title" class="submenu-title-wrapper"
              ><router-link
                :to="{ path: '/dangjian', query: { name: '党建工作' } }"
                tag="div"
              >
                党团工会</router-link
              ></span
            >
            <a-menu-item
              ><router-link
                :to="{ path: '/dangjian', query: { name: '党建工作' } }"
                tag="div"
              >
                党建工作</router-link
              ></a-menu-item
            >
          </a-sub-menu>
          <a-sub-menu @titleClick="titleClick">
            <span slot="title" class="submenu-title-wrapper"
              ><router-link
                :to="{ path: '/zhaosheng', query: { name: '招生信息' } }"
                tag="div"
                >招生工作</router-link
              ></span
            >
            <a-menu-item
              ><router-link
                :to="{ path: '/zhaosheng', query: { name: '招生信息' } }"
                tag="div"
                >招生信息</router-link
              ></a-menu-item
            >
            <a-menu-item
              ><router-link
                :to="{ path: '/zhaosheng', query: { name: '在线报名' } }"
                tag="div"
                >在线报名</router-link
              ></a-menu-item
            >
          </a-sub-menu>
          <a-sub-menu @titleClick="titleClick">
            <span slot="title" class="submenu-title-wrapper"
              ><router-link
                :to="{ path: '/techPrj', query: { name: '实习培训' } }"
                tag="div"
                >教学教研</router-link
              >
            </span>
            <a-menu-item
              ><router-link
                :to="{ path: '/techPrj', query: { name: '实习培训' } }"
                tag="div"
                >实习培训</router-link
              ></a-menu-item
            >
            <a-menu-item
              ><router-link
                :to="{ path: '/techPrj', query: { name: '师资培训' } }"
                tag="div"
                >师资培训</router-link
              ></a-menu-item
            >
            <a-menu-item
              ><router-link
                :to="{ path: '/techPrj', query: { name: '教研动态' } }"
                tag="div"
                >教研动态</router-link
              ></a-menu-item
            >
            <a-menu-item
              ><router-link
                :to="{ path: '/techPrj', query: { name: '教学活动' } }"
                tag="div"
                >教学活动</router-link
              ></a-menu-item
            >
          </a-sub-menu>
          <a-sub-menu @titleClick="titleClick">
            <span slot="title" class="submenu-title-wrapper"
              ><router-link
                :to="{ path: '/techCol', query: { name: '安全工作' } }"
                tag="div"
                >教育管理</router-link
              ></span
            >
            <a-menu-item
              ><router-link
                :to="{ path: '/techCol', query: { name: '安全工作' } }"
                tag="div"
                >安全工作</router-link
              ></a-menu-item
            >
            <a-menu-item
              ><router-link
                :to="{ path: '/techCol', query: { name: '校园文化' } }"
                tag="div"
                >校园文化</router-link
              ></a-menu-item
            >
            <a-menu-item
              ><router-link
                :to="{ path: '/techCol', query: { name: '学生活动' } }"
                tag="div"
                >学生活动</router-link
              ></a-menu-item
            >
            <a-menu-item
              ><router-link
                :to="{ path: '/techCol', query: { name: '德育动态' } }"
                tag="div"
                >德育动态</router-link
              ></a-menu-item
            >
          </a-sub-menu>
          <a-sub-menu @titleClick="titleClick">
            <span slot="title" class="submenu-title-wrapper"
              ><router-link
                :to="{ path: '/empExis', query: { name: '培训信息' } }"
                tag="div"
                >就业培训</router-link
              ></span
            >
            <a-menu-item
              ><router-link
                :to="{ path: '/empExis', query: { name: '培训信息' } }"
                tag="div"
                @click="peiXunMsg"
                >培训信息</router-link
              ></a-menu-item
            >
            <a-menu-item
              ><router-link
                :to="{ path: '/empExis', query: { name: '就业信息' } }"
                tag="div"
                >就业信息</router-link
              ></a-menu-item
            >
          </a-sub-menu>
          <a-sub-menu @titleClick="titleClick">
            <span slot="title" class="submenu-title-wrapper"
              ><router-link
                :to="{ path: '/scTeam', query: { name: '校企合作' } }"
                tag="div"
                >校企合作</router-link
              ></span
            >
            <a-menu-item
              ><router-link
                :to="{ path: '/scTeam', query: { name: '校企合作' } }"
                tag="div"
                >校企合作</router-link
              ></a-menu-item
            >
          </a-sub-menu>
          <a-sub-menu @titleClick="titleClick">
            <span slot="title" class="submenu-title-wrapper">
              <router-link :to="{ href: 'http://www.cnki.net/' }" tag="div"
                >数字图书馆</router-link
              >
            </span>
            <a-menu-item
              ><a target="_blank" href="http://www.cnki.net/"
                >中国知网</a
              ></a-menu-item
            >
            <a-menu-item
              ><a target="_blank" href="http://www.dooland.com/"
                >读览天下</a
              ></a-menu-item
            >
            <a-menu-item
              ><a target="_blank" href="http://www.sslibrary.com/"
                >超星图书馆</a
              ></a-menu-item
            >
            <a-menu-item
              ><a target="_blank" href="http://gsdpw.zhiye.chaoxing.com"
                >尔雅通识课</a
              ></a-menu-item
            >
            <a-menu-item
              ><a target="_blank" href="http://www.zhizhen.com"
                >超星发现</a
              ></a-menu-item
            ><a-menu-item
              ><a target="_blank" href="http://ssvideo.chaoxing.com/index.asp"
                >超星视频</a
              ></a-menu-item
            ><a-menu-item
              ><a target="_blank" href="http://www.duxiu.com/"
                >读秀</a
              ></a-menu-item
            >
            <a-menu-item
              ><a target="_blank" href="http://www.blyun.com/"
                >百链</a
              ></a-menu-item
            >
          </a-sub-menu>
          <!-- <a-sub-menu @titleClick="titleClick">
            <span slot="title" class="submenu-title-wrapper"
              ><router-link
                :to="{ path: '/zhaosheng', query: { name: '在线报名' } }"
                tag="div"
                >在线报名</router-link
              ></span
            >
          </a-sub-menu> -->
        </a-menu>
      </div>
    </a-affix>
  </div>
</template>

<script>
import { postNewsByPage, getScList } from "@/api/api";
export default {
  name: "indexNav",
  data() {
    return {
      current: ["mail"],
      top: 10,
      flag: false,
       li_classId:'',
      li_classCName:'',
    };
  },
   created() {
  
     getScList().then((res) => {
      console.log(res);
      
       this.li_classId = res[4].child[3].classId;
      this.li_classCName = res[4].child[3].classCName;
    });
    postNewsByPage(19682205716332, 1, 4).then((res) => {
      // //console.log(res);？
      this.list = res.list;
    });
  },
  methods: {
    menuSelect(el) {
      // console.log(1);
      // console.log(el);
    },
    menuClick(e) {
      // this.flag = !this.flag;
      // console.log(e);
      // console.log(2);
    },
    titleClick(e) {
      // console.log(e);
    },
    peiXunMsg() {
      this.$route.path("peiXunMsg");
      // console.log(1);
    },
  },
};
</script>

<style  scoped>
.ant-menu {
  display: flex;
  justify-content: center;
  background: none;
  border-bottom: none;
  color: white;
}
.ant-menu-submenu,
.ant-menu-submenu-popup,
.ant-menu-light,
.ant-menu-light,
.ant-menu-submenu-placement-topLeft {
  top: 0 !important;
}
.ant-menu-horizontal > .ant-menu-item,
.ant-menu-horizontal > .ant-menu-submenu {
  margin-right: 1%;
}
.ant-menu-horizontal > .ant-menu-item:hover,
.ant-menu-horizontal > .ant-menu-submenu:hover,
.ant-menu-horizontal > .ant-menu-item-active,
.ant-menu-horizontal > .ant-menu-submenu-active,
.ant-menu-horizontal > .ant-menu-item-open,
.ant-menu-horizontal > .ant-menu-submenu-open,
.ant-menu-horizontal > .ant-menu-item-selected,
.ant-menu-horizontal > .ant-menu-submenu-selected {
  color: white;
  border-bottom: 2px solid white;
  font-size: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/indexComp/indexNav.vue